import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try { await login(form.email, form.password); toast.success('Welcome back! 🥻'); navigate('/'); }
    catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };
  return (
    <div className="page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420, background: '#fff', border: '1px solid var(--border)', padding: '48px 40px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40 }}>🥻</div>
          <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, color: '#7c3aed', fontStyle: 'italic', marginTop: 8 }}>Welcome Back</h1>
          <p style={{ color: '#64748b', fontSize: 13, marginTop: 6 }}>Login to your Demo Shop account</p>
          <Link to="/login/otp" className="auth-inline-cta">Use Mobile OTP Instead</Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="your@email.com"/></div>
          <div className="form-group"><label className="form-label">Password</label><input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required placeholder="••••••••"/></div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '14px', marginTop: 8 }} disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button>
        </form>
        <div className="auth-divider"><span>or</span></div>
        <Link to="/login/otp" className="btn btn-outline auth-otp-btn">Continue with Mobile OTP</Link>
        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#64748b' }}>
          Don't have an account? <Link to="/register" style={{ color: '#7c3aed', fontWeight: 600 }}>Sign Up</Link>
        </div>
      </div>
    </div>
  );
}
